import templateUrl from './loading-admin-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    administration: '<',
    administrations: '<',
    animalTypes: '<',
    frequencies: '<',
    unitsDisplay: '<',
    submitTitle: '@',
    administrationChanged: '&',
    index: '<',
    showAdditionalButton: '<'
  },
  controller: class LoadingAdminFormComponent {
    constructor(AnimalTypeService, EventEmitter) {
      'ngInject';

      Object.assign(this, { AnimalTypeService, EventEmitter });
    }

    onSubmit(shouldClose) {
      const administration = {
        Isloading: true,
        ...this.administration
      };

      if (!administration.DoseId) {
        this.administrations.push(administration);
      }

      this.administrationChanged(
        this.EventEmitter({
          administration,
          index: this.index,
          shouldClose
        })
      );

      this.validateDuplicates();
    }

    getMinimumAnimalWeight(species) {
      return this.AnimalTypeService.minimumAnimalWeight(species);
    }

    getMaximumAnimalWeight(species) {
      return this.AnimalTypeService.maximumAnimalWeight(species);
    }

    validateDuplicates() {
      let isValid = true;

      if (this.administration) {
        const arrayIndex = this.administrations.findIndex(d =>
          d.Isloading === true
          && d.Species === this.administration.Species
          && d.MinWeight === this.administration.MinWeight
          && d.MaxWeight === this.administration.MaxWeight
          && d.DoseAmount === this.administration.DoseAmount
          && d.DosePerDay === this.administration.DosePerDay
          && d.LoadingPeriod === this.administration.LoadingPeriod
        );

        if (arrayIndex !== -1 && arrayIndex !== this.index) {
          isValid = false;
        }
      }

      this.loadingAdministrationForm.$setValidity('duplicate', isValid);
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/product/loading-admin-form/loading-admin-form.component.js